(ns app.domain.sign-off.sign-off-properties
  (:require [app.domain.form.model :as form-model]))


;; CHANGING THESE MIGHT BREAK HOW EXISTING SIGN-OFF FORMS ARE DISPLAYED.
(def default-props-for-tag
  {:sign-off/project-information                      [[{:ref :workspace/address}
                                                        {:ref :unit-number :source :form}
                                                        {:ref :lot-con :source :form}]
                                                       [{:ref :workspace/municipality}
                                                        {:ref :postal-code :source :form}
                                                        {:ref :plan-number :source :form}]
                                                       [{:ref :construction-cost :source :form}
                                                        {:ref :area-of-work :source :form}]]
   :sign-off/application-information                  [[{:ref :workspace/id}]
                                                       [{:ref :property/id}]
                                                       [{:ref :sign-off/submitted-to}]]
   :sign-off/purpose-of-application                   [[{:ref :application-type}]
                                                       [{:ref :proposed-use-of-building :source :form}
                                                        {:ref :current-use-of-building :source :form}]
                                                       [{:ref :description-of-work :source :form}]]
   ;; Planning
   :sign-off.planning/application-information         [[{:ref :workspace/id}]
                                                       [{:ref :property/id}]
                                                       [{:ref :sign-off/submitted-to}]]
   :sign-off.planning/description-of-subject-property [[{:ref :workspace/address}
                                                        {:ref :unit-number :source :form}
                                                        {:ref :lot-con :source :form}]
                                                       [{:ref :workspace/municipality}
                                                        {:ref :postal-code :source :form}
                                                        {:ref :plan-number :source :form}]
                                                       [{:ref :property/id}
                                                        {:ref :property/legal}]]
   :sign-off.planning/purpose-of-application          [[{:ref :proposed-development :source :form}]
                                                       [{:ref :existing-land-use :source :form}]
                                                       [{:ref :application-type}]
                                                       [{:ref :site-area :source :form}]]
   ;; Land Use
   :sign-off.land-use/description-of-subject-property [[{:ref :workspace/address}
                                                        {:ref :unit-number :source :form}
                                                        {:ref :lot-con :source :form}]
                                                       [{:ref :workspace/municipality}
                                                        {:ref :postal-code :source :form}
                                                        {:ref :plan-number :source :form}]
                                                       [{:ref :property/id}
                                                        {:ref :property/legal}]]
   :sign-off.land-use/purpose-of-application          [[{:ref :current-use-of-property :source :form}]
                                                       [{:ref :proposed-use-of-property :source :form}]
                                                       [{:ref :application-type}]
                                                       [{:ref :area-of-work :source :form}]]})


(defn legacy-property->ref [legacy-property]
  (case legacy-property
    :municipality :workspace/municipality
    legacy-property))


(defn resolve-properties-for-element [[tag attr]]
  (let [properties (when (map? attr)
                     (:properties attr))]
    (cond
      ;; Legacy case where properties were a coll of keywords
      (-> properties first keyword?)
      (->> (get default-props-for-tag tag)
           ;; Use default-props-for-tag as 'base' and remove fields that do not have a 'match' in properties
           (map #(filter (comp (->> properties
                                    (mapv legacy-property->ref)
                                    set)
                               :ref)
                         %))
           (remove empty?))

      properties
      properties

      :else
      (get default-props-for-tag tag))))


(defn- form-fields-referenced-in-props-for-schema [[_ _ & children :as element]]
  (concat
    (when (vector? element)
      (->> (resolve-properties-for-element element)
           flatten
           (filter #(-> % :source (= :form)))
           (map :ref)))
    (->> children
         (filter vector?)
         (mapcat form-fields-referenced-in-props-for-schema))))


(defn form-fields-referenced-in-props
  "First gets the schema of the form and then finds form fields that are referenced in properties.

  On sign off forms we often want to display form fields from other forms and the (correct) way to do this is
  to reference these fields in properties"
  [form]
  (-> (form-model/get-form-data-schema form)
      form-fields-referenced-in-props-for-schema))
